import { Autocomplete } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const StyledAutocomplete = styled(Autocomplete)`
  min-width: 280px;
  height: 48px;
  flex-grow: 1;
  background: transparent;
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  color: ${theme.colors.devicesSecondaryText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.normal};
  line-height: 20px;

  &.Mui-focused {
    border: 1px solid ${theme.colors.cta};
  }

  .MuiOutlinedInput-root {
    padding: 0 ${theme.spacing.small}px;
    height: 48px;
    min-width: 280px;
    border-radius: ${theme.attributes.borderRadius.tertiary};
    border: 0;
    outline: 0;
    background: transparent;

    .MuiInputAdornment-root {
      svg {
        path {
          fill: ${theme.colors.devicesSecondaryText};
        }
      }
    }

    .MuiOutlinedInput-input {
      padding-left: ${theme.spacing.md}px;
      padding-top: 0;
      padding-bottom: 0;
      height: 48px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${theme.colors.menuItemText};
      -webkit-text-fill-color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;

      &::placeholder {
        opacity: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.colors.devicesSecondaryText};
        -webkit-text-fill-color: ${theme.colors.devicesSecondaryText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 20px;
      }
    }
  }

  fieldset {
    border: none;
    outline: none;
  }
`
